'use client';
var classes = {"root":"m_cd8943fd"};

export { classes as default };
//# sourceMappingURL=PieChart.module.css.mjs.map
